// eslint-disable-next-line import/no-cycle
import { TYPE } from '../feed-item-layout'

const getProductEventType = (products) => {
  const isSingleProduct = products && products.length === 1
  return isSingleProduct ? 'FeaturedProduct' : 'Products'
}

const getItemType = (type, products) => {
  if (type === TYPE.PRODUCTS) {
    return getProductEventType(products)
  }
  if (type === TYPE.ADD_ITEMS) {
    return 'AddItemsFromSuggestions'
  }
  return type[0].toUpperCase() + type.slice(1)
}

export { getItemType }
